<template>
    <transition name="fade">
            <div class="container">
                <!--<header class="page-header">
                    <router-link class="back-link" to="/">
                        <svg class="svg-icon-arrow-left svg-icon" width="24" height="11">
                            <use xlink:href="#arrow-left"></use>
                        </svg>
                    </router-link>
                    <a class="page-header__logo" href="/"><img src="assets/images/logo.svg" alt=""></a>
                </header>-->
                <h1 :class="{'hidden':!inputPhone}" class="title-logo">Телефон</h1>
                <p :class="{'hidden':!inputPhone}">Нажимая "Вход или регистрация", вы соглашаетесь с <a href="/">Ссылка</a> и <a href="/">Ссылка</a></p>
                <form :class="{'hidden':!inputPhone}" class="flex-form" action="/">
                    <div class="bottom-section">
                        <input v-model="v$.phone.$model" type="text" :class="{'_is-error':v$?.phone?.$errors[0]?.$message.length > 0}" inputmode="tel" v-maska data-maska="+7 (###) ###-##-##" placeholder="Телефон" id="input-phone">
                        <button @click="login"  class="primary-btn lg-btn wide-btn"   :class="{'btn--loading':loading}"  type="button">
                            <span class="btn__text">Вход / регистрация</span>
                        </button>
                        <router-link to="/" class="neutral-btn lg-btn wide-btn" type="button">Закрыть</router-link>
                    </div>
                </form>
                <!--<header class="page-header">
                    <router-link class="back-link" to="/">
                        <svg class="svg-icon-arrow-left svg-icon" width="24" height="11">
                            <use xlink:href="#arrow-left"></use>
                        </svg>
                    </router-link>
                    <a class="page-header__logo" href="/"><img src="assets/images/logo.svg" alt=""></a>
                </header>-->
                <h1 :class="{'hidden':inputPhone}" class="title-logo">Код из СМС</h1>
                <p :class="{'hidden':inputPhone}">Мы отправили проверочный код на номер <strong>{{phone}}</strong></p>
                <div :class="{'hidden':inputPhone}" class="bottom-section">
                    <form action="/">
                        <div class="input-wrap">
                            <input v-model="code"  type="tel" placeholder="Код из смс..." id="sms" />
                        </div>
                        <button v-if="time > 0" class="primary-btn lg-btn wide-btn" type="button" disabled="disabled"><span>Повторить СМС <span class="btn-timer">{{time}}</span></span></button>
                        <button v-else @click="login" class="primary-btn lg-btn wide-btn" type="button"><span>Повторить СМС</span></button>
                    </form>
                </div>


                <div class="modal modal--msg micromodal-slide" :class="{'is-open':loadingCode || auth}" id="modal-file-loading" aria-hidden="true">
                    <div class="modal__overlay" tabindex="-1" data-micromodal-close="">
                        <div class="modal__container" role="dialog" aria-modal="true">
                            <div class="modal__title">Вход</div>
                            <div class="modal__inner">
                                <div class="modal__area">
                                    <div v-if="loadingCode" class="modal__loading">
                                        <div class="lg-loader"></div>
                                        <div class="modal__msg-text">Вход...</div>
                                    </div>
                                    <div v-if="auth" class="modal__success">
                                        <svg class="svg-icon--tick svg-icon" width="38" height="28">
                                            <use xlink:href="#tick"></use>
                                        </svg>
                                        <div class="modal__msg-title">Готово!</div>
                                        <div class="modal__msg-text">Вы успешно авторизованы</div>
                                    </div>
                                </div>
                                <div v-if="auth" class="modal__btns modal__btns--no-margin">
                                    <button @click="toBasket" class="modal__btn btn secondary-btn round-btn" type="button">В корзину</button>
                                    <button @click="toOrder" class="modal__btn btn secondary-btn round-btn" type="button">К заказам</button>
                                </div>
                            </div>
                            <!--<button class="modal__btn modal__close btn" @click="" data-micromodal-close>
                                <svg class="svg-icon--close svg-icon" width="15" height="15">
                                    <use xlink:href="#close"></use>
                                </svg>
                            </button>-->
                        </div>
                    </div>
                </div>
                
            </div>
    </transition>
</template>

<style scoped>
    .flex-form .neutral-btn{
        margin-top: 10px;
    }
</style>

<script>


    import {HTTP} from "../modules/http-common"

    import { useVuelidate } from "@vuelidate/core";
    import { required, email } from "@vuelidate/validators";

    import { reactive, computed, toRef} from 'vue'


    export default {
        props: ['instance'],

        name: 'Auth',

        data: function(){
            return {
                inputPhone:true,
                code:'',
                time:60,
                loading:false,
                loadingCode:false,
                auth:false,
            };
        },

        watch: {
            code: function(val, oldVal) {
                if(val.length >= 6){
                    this.confirm();
                }
            }
        },

        created() {

            this.$root.scrollable = false;

            this.$root.pageClass = "";

        },

        mounted:function () {


        },

        components: {},

        setup() {
            const loginForm = reactive({
                phone: '',
            });
            const confirmForm = reactive({
                code: '',
            });
            const rules = {
                phone: { required },
            };
            const rulesConfirm = {
                code: { required },
            };
            const v$ = useVuelidate(rules, {
                phone: toRef(loginForm, "phone"),
            });

            const vconfirm$ = useVuelidate(rulesConfirm, {
                code: toRef(confirmForm, "code"),
            });

            return { loginForm, v$, vconfirm$ }
        },

        methods:{

            toBasket: function(){
                this.auth = false;
                this.$router.push('/basket');
            },
            toOrder: function(){
                this.auth = false;
                this.$router.push('/orders');
            },

            startTimer: function(){
                let $this = this;
                $this.time = 60;
                let interTimer = setInterval(function () {
                    $this.time--;
                    if($this.time <= 0)
                        clearInterval(interTimer);
                }, 1000);
            },

            login: function () {

                let vm = this;

                vm.v$.$touch();

                if (vm.v$.$invalid)
                    return;

                vm.loading = true;

                const params = JSON.stringify({phone: vm.loginForm.phone});

                HTTP.post(
                    '/auth/login',
                    params
                ).then(function (response) {
                    if(response.data.status == 'error'){
                        vm.loading = false;
                        alert(response.data.message);
                    }else{
                        vm.loading = false;
                        vm.startTimer();
                        vm.inputPhone = false;
                    }
                });
            },

            confirm:function () {

               let $this = this;

               if($this.code.length == 6 && !$this.loading){

                   $this.loadingCode = true;

                   const params = JSON.stringify({
                       phone: this.loginForm.phone,
                       sms_code: this.code,
                   });

                   //$this.code = "";

                   document.activeElement.blur();

                   HTTP.post(
                       '/auth/confirm',
                       params
                   ).then(function (response) {
                       if(response.data.status == 'error'){
                           alert(response.data.message);
                           $this.loadingCode = false;
                       }else{
                           $this.$store.dispatch("fetchStart").then(function(){
                               //$this.$router.push('/');
                               setTimeout(function () {
                                   $this.loadingCode = false;
                                   $this.auth = true;
                               }, 2000);
                           });
                       }
                   });
               }
            }
        },

        validations() {
            return {}
        },
    }
</script>
